import React from 'react';

import type { IClassNameProps } from '@bem-react/core';

import type { IconProps } from '../../Icon';
import { cnButton } from '../Button.cn';
import type { ButtonProps } from '../Button.types';

export type ButtonIconProps = Pick<ButtonProps, 'size'> &
    Pick<IconProps, 'color'> & {
        icon: ButtonProps['icon'];
        align?: 'left' | 'right';
    };

const getIconSize = (buttonSize: ButtonProps['size']) => {
    switch (buttonSize) {
        case 'l':
            return 'm';
        default:
            return 's';
    }
};

const getThemedIcon = (props: Omit<ButtonIconProps, 'icon'> & IClassNameProps) => {
    return (el: ButtonIconProps['icon']) => {
        if (!el) return el;

        if (React.isValidElement<IconProps>(el)) {
            return React.cloneElement(el, {
                ...props,
                ...el.props,
                className: [props.className, el.props?.className].filter(Boolean).join(' '),
            });
        }
        return React.createElement(el as React.FC<IconProps>, props);
    };
};

export const ButtonIcon: React.FC<ButtonIconProps> = (props) => {
    const { icon, size, color, align } = props;

    const iconSize = getIconSize(size);
    const themed = getThemedIcon({
        size: iconSize,
        color,
        className: cnButton('Icon', { align }),
    });

    return themed(icon) || null;
};
